import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const TermsPage = () => {
  return (
    <div className="min-h-screen w-full relative overflow-hidden">
      {/* Gradient Background */}
      <div className="absolute inset-0 z-0">
        <div 
          className="absolute inset-0"
          style={{
            background: `linear-gradient(135deg, #ff9a56 0%, #ff6b8a 25%, #c44eff 50%, #7b68ee 75%, #00bfff 100%)`,
            backgroundSize: '400% 400%',
            animation: 'gradientShift 15s ease infinite'
          }}
        />
      </div>

      {/* Header */}
      <header className="relative z-10 p-6 flex items-center justify-between">
        <Link to="/" className="text-2xl font-bold tracking-tight text-black hover:opacity-80 transition-opacity">
          Spooker
        </Link>
        <Link 
          to="/login" 
          className="flex items-center gap-2 text-sm text-neutral-700 hover:text-black transition-colors"
        >
          <ArrowLeft className="h-4 w-4" />
          Terug naar inloggen
        </Link>
      </header>

      {/* Content */}
      <div className="relative z-10 flex items-center justify-center min-h-[calc(100vh-120px)] px-4 py-8">
        <div className="w-full max-w-3xl">
          <div className="bg-white rounded-xl shadow-2xl overflow-hidden">
            <div className="p-8 md:p-12">
              <h1 className="text-3xl font-bold text-neutral-900 mb-6">
                Algemene Voorwaarden
              </h1>
              
              <div className="prose prose-neutral max-w-none">
                <p className="text-neutral-600 mb-6">
                  Laatst bijgewerkt: 21 februari 2026
                </p>

                <section className="mb-8">
                  <h2 className="text-xl font-semibold text-neutral-800 mb-3">1. Definities</h2>
                  <p className="text-neutral-600 leading-relaxed">
                    In deze algemene voorwaarden wordt verstaan onder:
                  </p>
                  <ul className="list-disc list-inside text-neutral-600 space-y-2 ml-4 mt-3">
                    <li><strong>Spooker:</strong> Spooker B.V., gevestigd te Nederland</li>
                    <li><strong>Platform:</strong> De Spooker cybersecurity GGRC applicatie</li>
                    <li><strong>Gebruiker:</strong> De natuurlijke of rechtspersoon die gebruik maakt van het Platform</li>
                    <li><strong>Diensten:</strong> Alle door Spooker aangeboden producten en diensten</li>
                  </ul>
                </section>

                <section className="mb-8">
                  <h2 className="text-xl font-semibold text-neutral-800 mb-3">2. Toepasselijkheid</h2>
                  <p className="text-neutral-600 leading-relaxed">
                    Deze algemene voorwaarden zijn van toepassing op alle overeenkomsten tussen Spooker en de Gebruiker. Door gebruik te maken van het Platform gaat u akkoord met deze voorwaarden.
                  </p>
                </section>

                <section className="mb-8">
                  <h2 className="text-xl font-semibold text-neutral-800 mb-3">3. Dienstverlening</h2>
                  <p className="text-neutral-600 leading-relaxed mb-3">
                    Spooker biedt een platform voor:
                  </p>
                  <ul className="list-disc list-inside text-neutral-600 space-y-2 ml-4">
                    <li>Cybersecurity assessments en risicobeheer</li>
                    <li>Governance, Risk en Compliance (GRC) management</li>
                    <li>Koppeling met cybersecurity leveranciers via de marketplace</li>
                    <li>Rapportage en monitoring van cybersecurity status</li>
                  </ul>
                </section>

                <section className="mb-8">
                  <h2 className="text-xl font-semibold text-neutral-800 mb-3">4. Gebruikersverplichtingen</h2>
                  <p className="text-neutral-600 leading-relaxed mb-3">
                    De Gebruiker verplicht zich om:
                  </p>
                  <ul className="list-disc list-inside text-neutral-600 space-y-2 ml-4">
                    <li>Accurate en volledige informatie te verstrekken</li>
                    <li>Accountgegevens vertrouwelijk te houden</li>
                    <li>Het Platform niet te misbruiken of te gebruiken voor illegale doeleinden</li>
                    <li>Intellectuele eigendomsrechten te respecteren</li>
                  </ul>
                </section>

                <section className="mb-8">
                  <h2 className="text-xl font-semibold text-neutral-800 mb-3">5. Marketplace</h2>
                  <p className="text-neutral-600 leading-relaxed">
                    Via de Spooker Marketplace kunnen Gebruikers in contact komen met cybersecurity leveranciers. Spooker faciliteert dit contact maar is geen partij bij overeenkomsten tussen Gebruikers en leveranciers. Spooker garandeert niet de kwaliteit of geschiktheid van leveranciers.
                  </p>
                </section>

                <section className="mb-8">
                  <h2 className="text-xl font-semibold text-neutral-800 mb-3">6. Aansprakelijkheid</h2>
                  <p className="text-neutral-600 leading-relaxed">
                    Spooker is niet aansprakelijk voor indirecte schade, gevolgschade of gederfde winst. De totale aansprakelijkheid van Spooker is beperkt tot het bedrag dat de Gebruiker in de voorafgaande 12 maanden aan Spooker heeft betaald.
                  </p>
                </section>

                <section className="mb-8">
                  <h2 className="text-xl font-semibold text-neutral-800 mb-3">7. Intellectueel Eigendom</h2>
                  <p className="text-neutral-600 leading-relaxed">
                    Alle intellectuele eigendomsrechten met betrekking tot het Platform en de Diensten berusten bij Spooker. De Gebruiker verkrijgt uitsluitend een beperkt gebruiksrecht.
                  </p>
                </section>

                <section className="mb-8">
                  <h2 className="text-xl font-semibold text-neutral-800 mb-3">8. Beëindiging</h2>
                  <p className="text-neutral-600 leading-relaxed">
                    Spooker kan de toegang tot het Platform opschorten of beëindigen bij schending van deze voorwaarden. De Gebruiker kan het account te allen tijde beëindigen via de accountinstellingen.
                  </p>
                </section>

                <section className="mb-8">
                  <h2 className="text-xl font-semibold text-neutral-800 mb-3">9. Toepasselijk Recht</h2>
                  <p className="text-neutral-600 leading-relaxed">
                    Op deze voorwaarden is Nederlands recht van toepassing. Geschillen worden voorgelegd aan de bevoegde rechter te Amsterdam.
                  </p>
                </section>

                <section className="mb-8">
                  <h2 className="text-xl font-semibold text-neutral-800 mb-3">10. Contact</h2>
                  <p className="text-neutral-600 leading-relaxed">
                    Voor vragen over deze voorwaarden kunt u contact opnemen via info@spooker.nl.
                  </p>
                </section>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="relative z-10 p-6 flex items-center justify-between text-sm text-neutral-600">
        <span>© 2026 Spooker</span>
        <div className="flex gap-4">
          <Link to="/privacy" className="hover:text-neutral-900">Privacy</Link>
          <Link to="/terms" className="text-neutral-900 font-medium">Voorwaarden</Link>
        </div>
      </footer>

      <style>{`
        @keyframes gradientShift {
          0% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
          100% { background-position: 0% 50%; }
        }
      `}</style>
    </div>
  );
};

export default TermsPage;
